import { createFileRoute } from '@tanstack/react-router';
import { requireRole, requireCampaign } from '@/lib/routeGuards';
import { useCampaignStore } from '@/stores';
import { ProfilePageContent } from '@/components/admin/messaging';

// Messaging Profile is an internal operator surface — platform-admin only, mirroring
// the backend's platform-admin gate. `requireRole(['admin'])` redirects any non-
// platform-admin to /app. The profile is 1:1 with the selected campaign (the API needs the
// X-Campaign-Id header). The registration list links here with `?campaignId=`, which the admin
// layout's deep-link hook turns into the selected campaign, so that link skips the guard.
export const Route = createFileRoute('/admin/messaging/profile')({
  validateSearch: (search: Record<string, unknown>): { campaignId?: string } =>
    typeof search.campaignId === 'string' ? { campaignId: search.campaignId } : {},
  beforeLoad: ({ context, search }) => {
    requireRole(context, ['admin'], '/admin/messaging/profile');
    if (!search.campaignId) requireCampaign('/app/home');
  },
  component: MessagingProfilePage,
});

function MessagingProfilePage() {
  const hasCampaign = useCampaignStore((s) => s.selectedCampaign !== null);
  if (!hasCampaign) {
    return <div className="p-6 text-muted-foreground">Opening campaign…</div>;
  }
  return <ProfilePageContent />;
}
